export default __webpack_public_path__ + "static/media/ElephantsDream.39427226.jpg";